import { render, staticRenderFns } from "./ProductionInfo.vue?vue&type=template&id=643d2c07&scoped=true&"
import script from "./ProductionInfo.vue?vue&type=script&lang=js&"
export * from "./ProductionInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductionInfo.vue?vue&type=style&index=0&id=643d2c07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d2c07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListTile,VListTileTitle,VMenu})
